import {createFetchBasedHttpClient, createTenantAwareFetchBasedHttpClient} from "@web-libs/core/http";

export const provideHttpClient = () => {
    return createFetchBasedHttpClient()
}

export const provideTenantAwareHttpClient = (tenantId: string, lang?: string) => {
    return createTenantAwareFetchBasedHttpClient(tenantId, lang)
}
